define.alias("shared/components/shared/ember-drop-multi-select", "calendar/components/shared/ember-drop-multi-select");